var path = '/forms/services/show-toast.html';
var html = "<md-toast class=\"custom {{toast.type}}\"> <div class=md-toast-content> <span flex role=alert aria-relevant=all aria-atomic=true> {{toast.message}} </span> </div> </md-toast> ";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;


//////////////////
// WEBPACK FOOTER
// ./forms/services/show-toast.html
// module id = 109
// module chunks = 0